import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  // {
  //   path: "",
  //   component: () => import("@/views/default/index.vue"),
  //   children: [
  {
    path: "",
    component: () => import("@/views/default/index.vue"),
    children: [
      {
        path: "",
        name: "home",
        component: () => import("@/views/default/_rightBar.vue")
      },
      {
        path: "/slot",
        name: "slot",
        component: () => import("@/views/default/_slot.vue")
      },
      {
        path: "/fishing",
        name: "fishing",
        component: () => import("@/views/default/_fishing.vue")
      },
      {
        path: "/casino",
        component: () => import("@/views/default/_casino.vue")
      },
      {
        path: "/return",
        component: () => import("@/views/default/_return.vue"),
        // redirect: to =>{
        //   return { path: '/statement', query: { q: 'history' }}
        // },
        meta: { requiredLoggedIn: true}
      },
      {
        path: "/statement",
        name: "/statement",
        component: () => import("@/views/default/_statement.vue"),
        props:true,
        children: [
          {
            path: "*",
            redirect: "/statement",
            meta: { requiredLoggedIn: true}
          }
        ],
        meta: { requiredLoggedIn: true}
      },
      // {
      //   path: "/contactUs",
      //   component: () => import("@/views/default/_contactUs.vue")
      // },
      {
        path: "/promotions",
        component: () => import("@/views/default/_promotions.vue")
      },
      // {
      //   name: "promo-details",
      //   path: "/promoDetails",
      //   component: () => import("@/views/default/_promotionDetails.vue"),
      //   children: [
      //     {
      //       path: "*",
      //       redirect: "/promoDetails"
      //     }
      //   ]
      // },
      {
        path: "/refresh",
        name: "refresh",
        component: () =>import("@/views/default/_refresh.vue")
      },
      {
        path: "/rubyplay",
        name: "rubyplay",
        component: () => import("@/component/slot/_nekoGame.vue"),
      },
      {
        path: "/amatic",
        name: "amatic",
        component: () => import("@/component/slot/_nekoGame.vue"),
      },
      {
        path: "/vegas",
        name: "vegas",
        component: () => import("@/component/slot/_nekoGame.vue"),
      },
      {
        path: "/scientificgames",
        name: "scientificgames",
        component: () => import("@/component/slot/_nekoGame.vue"),
      },
      {
        path: "/pragmatic",
        name: "pragmatic",
        component: () => import("@/component/slot/_nekoGame.vue"),
      },
      {
        path: "/novomatic",
        name: "novomatic",
        component: () => import("@/component/slot/_nekoGame.vue"),
      },
      {
        path: "/microgaming",
        name: "microgaming",
        component: () => import("@/component/slot/_nekoGame.vue"),
      },
      {
        path: "/ainsworth",
        name: "ainsworth",
        component: () => import("@/component/slot/_nekoGame.vue"),
      },
      {
        path: "/quickspin",
        name: "quickspin",
        component: () => import("@/component/slot/_nekoGame.vue"),
      },
      {
        path: "/apollo",
        name: "apollo",
        component: () => import("@/component/slot/_nekoGame.vue"),
      },
      {
        path: "/NetEnt",
        name: "NetEnt",
        component: () => import("@/component/slot/_nekoGame.vue"),
      },
      {
        path: "/igt",
        name: "igt",
        component: () => import("@/component/slot/_nekoGame.vue"),
      },
      {
        path: "/aristocrat",
        name: "aristocrat",
        component: () => import("@/component/slot/_nekoGame.vue"),
      },
      {
        path: "/igrosoft",
        name: "igrosoft",
        component: () => import("@/component/slot/_nekoGame.vue"),
      },
      {
        path: "/apex",
        name: "apex",
        component: () => import("@/component/slot/_nekoGame.vue"),
      },
      {
        path: "/gclub",
        name: "gclub",
        component: () => import("@/component/slot/_nekoGame.vue"),
      },
      {
        path: "/wazdan",
        name: "wazdan",
        component: () => import("@/component/slot/_nekoGame.vue"),
      },
      {
        path: "/egt",
        name: "egt",
        component: () => import("@/component/slot/_nekoGame.vue"),
      },
      {
        path: "/live22",
        component: () => import("@/component/slot/_live22.vue"),
      },
      {
        path: "/kingkong",
        component: () => import("@/component/slot/_kingkong.vue"),
      },
      {
        path: "/live22fish",
        component: () => import("@/component/fishing/_live22.vue"),
      },
      {
        path: "/kingkongfish",
        component: () => import("@/component/fishing/_kingkong.vue"),
      },
      {
        path: "/fish",
        name: "fish",
        component: () => import("@/component/fishing/_nekoGame.vue"),
      },
      {
        path: "/peg",
        name: "peg",
        component: () => import("@/component/slot/_peg.vue"),
      },
      {
        path: "/uuslot",
        name: "uuslot",
        component: () => import("@/component/slot/_uuslot.vue"),
      }
    ]
  },
  {
    path: "/betdetail",
    name: "/betdetail",
    component: () => import("@/component/gameResult/_nekoBetDetail.vue"),
    props:true,
    children: [
      {
        path: "*",
        redirect: "/betdetail",
        meta: { requiredLoggedIn: true}
      }
    ],
    meta: { requiredLoggedIn: true}
  },
  {
    path: "*",
    component: () => import("@/views/default/_errorPage.vue")
  },
  //   ]
  // }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
